class VerifyUser extends HTMLElement {
    constructor() {
        super();
        this.customer_id = window.customerApi.getShopifyID();
        this.fileInput = null;
        this.label = null;
        this.existing_customer = null;
        this.type = null;
    }

    connectedCallback() {
        this.fileInput = this.querySelector("input[type=file]");
        this.existing_customer = this.querySelector("a.existing-customer");
        this.label = this.querySelector("label");
        if (this.fileInput) {
            this.fileInput.addEventListener("change", async () => {
                this.type = this.dataset.verificationType;
                await this.processData();
            });
        }

        if (this.existing_customer) {
            this.existing_customer.addEventListener("click", async (event) => {
                this.type = this.dataset.verificationType;
                event.preventDefault();
                await this.processData();
            });
        }
    }

    async processData() {
        if (this.fileInput) {
            const file = this.fileInput.files[0];
            if (file && file instanceof File) {
                const fileName = file.name;
                this.label.innerHTML = fileName;

                // if file size greater than 1MB, cannot upload
                // having this because I was having CORS error when uploading a file greater than 1MB
                if (file.size > 1048576) {
                    window.showToast("error", {
                        title: "File size is too big",
                        message: "Please upload a file less than or equal to 1MB",
                    });
                    return;
                }
                // need to add confirmation modal before submit the file.
                const is_confirmed = await this.showConfirmationModal(this.type);
                console.log("is_confirmed -> ", is_confirmed);
                if (is_confirmed) {
                    this.verificationProcess(file);
                }
            } else {
                window.showToast("error", {
                    title: "Invalid file format",
                    message: "Please upload a valid file format",
                });
            }
        } else if (this.existing_customer) {
            const is_confirmed = await this.showConfirmationModal(this.type);
            console.log("is_confirmed -> ", is_confirmed);
            if (is_confirmed) {
                const note_text = `Applied for verification as an existing customer ${this.customer_id}.`;
                this.verificationProcess(null, note_text);
            }
        } else {
            window.showToast("error", {
                title: "Verification Failed",
                message: "Please try again with valid input",
            });
        }
    }

    async verificationProcess(file = null, note = null) {
        try {
            const response = await window.customerApi.verify(this.customer_id, file, note);
            const data = await response.json();
            const { has_submitted_form, is_verified } = data.data;

            const notVerifiedDetails = document.querySelector(
                ".customer-not-verified-details"
            );
            const verifiedDetails = document.querySelector(
                ".customer-verified-details"
            );
            const pendingDetails = document.querySelector(
                ".customer-pending-details"
            );

            if (is_verified) {
                // verified
                hideElement(notVerifiedDetails);
                hideElement(pendingDetails);
                showElement(verifiedDetails);
            } else if (!is_verified && has_submitted_form) {
                // pending
                hideElement(notVerifiedDetails);
                hideElement(verifiedDetails);
                showElement(pendingDetails);
            } else if (!is_verified && !has_submitted_form) {
                // not verified, so upload info
                showElement(notVerifiedDetails);
                hideElement(verifiedDetails);
                hideElement(pendingDetails);
            }

            // console.log(data);
        } catch (error) {
            window.showToast("error", {
                title: "Error occurred",
                message: "Please try again",
            });
            console.log(error);
        }
    }

    showConfirmationModal(verificationType) {
        const confirmationModal = document.querySelector("#confirmation_popup");
        const confirmBtn = confirmationModal.querySelector('#confirmButton');
        const cancelBtn = confirmationModal.querySelector('#cancelButton');
        const closeBtn = confirmationModal.querySelector('.popup__close');
        const body_text = confirmationModal.querySelector('.body_text');
        
        if (verificationType === "exist") {
            body_text.innerHTML = "By confirming, you agree to being an existing eMedals customer. We will review your account information and approve if feasible.";
        } else if (verificationType === "id-upload") {
            body_text.innerHTML = "By confirming, you will submit the copy of your photo ID to verify your name and address.";
        } else if (verificationType === "bill-upload") {
            body_text.innerHTML = "By confirming, you agree to submit the copy of your recent bill (utility or mobile) to verify your name and address.";
        }

        window.utils.openIDConfirmationModal();
        return new Promise((resolve) => {
            if (confirmBtn) {
                confirmBtn.addEventListener('click', () => {
                    resolve(true);
                    closeBtn.dispatchEvent(new Event("click"));
                });
            }

            if (cancelBtn) {
                cancelBtn.addEventListener('click', () => {
                    resolve(false);
                });
            }
        });
    }
}

customElements.define("verify-user", VerifyUser);